export default "__VITE_PUBLIC_ASSET__a97c4b5a__"